import React from "react";
import useInput from "../../../hooks/useInput";
import {Box, Button, Column, Title} from "@allxsmith/bestax-bulma";
import {usePostFitter} from "../../../hooks/usePostFitter";


function NewFitter(){

    let [fitterName, fitterInput, setFitterName] = useInput({
        type: "text",
        label: "Fitter Name"
    });

    const [,postFitter] = usePostFitter({
        name: fitterName
    });
    const handleSubmit = () => {
        postFitter().then(setFitterName(""));
    }
    return (
        <Box>
            <details>
                <summary><Title>Add Fitter</Title></summary>
            <Column>
                {fitterInput}
            </Column>
            <Column>
                <Button
                    onClick={handleSubmit}
                    color={"success"}
                    isFullWidth
                >
                    Add Fitter
                </Button>
            </Column>
            </details>
        </Box>
    );

}
export default NewFitter;